module.exports = __webpack_public_path__ + "static/img/limit_02.4cd06ab2.svg";